// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// LAYERS SECTION DESKTOP ANIMATION

//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const scroll = window.requestAnimationFrame;

function showOnScroll() {
  const elems = document.querySelectorAll(".msdw-animate");

  elems.forEach((el) => {
    const elPosition = el.getBoundingClientRect().top;
    const elScreen = window.innerHeight / 0.9;

    if (elPosition < elScreen) {
      el.classList.add("msdw-animated");
    }
  });

  scroll(showOnScroll);
}

showOnScroll();

//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const sliderThumbs = new Swiper("#sliderThumbs", {
  slidesPerView: 3,
  loop: false,
});

const breakpoint = window.matchMedia("(min-width: 900px)");

let sliderLayers;
let sliderWeather;

const breakpointChecker = function () {
  if (breakpoint.matches === true) {
    if (sliderLayers !== undefined) sliderLayers.destroy(true, true);
    if (sliderWeather !== undefined) sliderWeather.destroy(true, true);
    return;
  } else if (breakpoint.matches === false) {
    return enableSwiper();
  }
};

const enableSwiper = function () {
  sliderLayers = new Swiper("#sliderLayers", {
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 50,
    loop: false,
    autoHeight: true,
    navigation: {
      prevEl: ".msdw-layers-button-prev",
      nextEl: ".msdw-layers-button-next",
    },
    thumbs: {
      swiper: sliderThumbs,
    },
    breakpoints: {
      900: {
        noSwipingClass: "msdw-no-swipe--lg",
        speed: 500,
      },
    },
  });

  sliderWeather = new Swiper("#sliderWeather", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      prevEl: ".msdw-weather-button-prev",
      nextEl: ".msdw-weather-button-next",
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
        freeMode: {
          enabled: true,
          sticky: true,
        },
      },
    },
  });
};

breakpoint.addEventListener("change", breakpointChecker);

breakpointChecker();

//
// =LAYERS SECTION DESKTOP ANIMATION
// --------------------------------------------------

// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.6.1/gsap.min.js"></script>
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.6.1/ScrollTrigger.min.js"></script>

// gsap.defaults({
//   ease: Linear.easeNone,
// });

// ScrollTrigger.matchMedia({
//   "(min-width:900px)": function () {
//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: ".msdw-section-layers",
//         scrub: 0.1,
//         pin: ".landingpage-wrapper",
//         start: "top 60px",
//       },
//     });

//     tl.call(() => sliderLayers.slideTo(0));
//     tl.to(".msdw-section-weather", 1, { opacity: 0.333 });
//     tl.call(() => sliderLayers.slideTo(1));
//     tl.to(".msdw-section-weather", 1, { opacity: 0.666 });
//     tl.call(() => sliderLayers.slideTo(2));
//     tl.to(".msdw-section-weather", 1, { opacity: 1 });
//   },
// });
